import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {Subscription} from 'rxjs';

import {InvoicesService} from '../../services/invoices.service';
import {InvoiceViewModel} from '../../viewModels/invoice.viewModel';
import {PaymentStatuses} from 'src/app/modules/shared/enums/paymentStatuses.enum';
import {Constants} from 'src/app/modules/shared/config/constants.config';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {UsersService} from '../../../shared/services/users.service';
import {SubscriptionViewModel} from '../../../shared/viewModels/subscription.viewModel';
import {LocalisationService} from '../../../shared/services/localisation.service';
import * as moment from 'moment/moment';
import {Router} from '@angular/router';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoicesComponent implements OnInit {
    invoices: InvoiceViewModel[];
    paymentStatuses = PaymentStatuses;
    currentSubscription: SubscriptionViewModel;

    constructor(
        private readonly invoicesService: InvoicesService,
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        public readonly constants: Constants,
        private readonly router: Router,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly localisationService: LocalisationService,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.usersService.getUserSubscription().subscribe(subcription => {
            this.currentSubscription = subcription;
        });

        this.invoicesService.getInvoices().subscribe(invoices => {
            this.invoices = invoices;
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.changeDetectorRef.markForCheck();
        });
    }

    cancelUserSubscription() {
        if (confirm(this.localisationService.localise('delete_user_subscription_confirm'))) {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

            this.usersService.deleteUserSubscription().subscribe(() => {
                this.usersService.getUserSubscription().subscribe(subcription => {
                    this.currentSubscription = subcription;
                    this.changeDetectorRef.markForCheck();

                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                }, () => {
                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                    this.router.navigate(['/']);
                });
            });
        }
    }

    getFreePricingPlanId() {
        return 4;
    }

    formatDate(date: string) {
        return moment(date).format('DD.MM.YYYY');
    }
}
